<template>
  <el-dialog
    :title="title"
    :visible.sync="$parent.uploadCancelDialogStatus"
    class="del-dialog"
  >
    <span slot="footer" class="dialog-footer btn-wrap">
      <el-button @click="$parent.uploadCancelDialogStatus = false">
        取 消
      </el-button>
      <el-button type="primary" @click.stop="confirm">{{
        confirmtext
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    confirmtext: {
      type: String,
      default: "确 定",
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
